/**
 * Created by Karol Kluska on 19.12.17.
 */

angular
  .module('app')
  .filter('datepickerTranslateMonth', translateMonth);

function translateMonth($interpolate) {
  return function (input) {
    return input.toUpperCase()
      .replace(/JANUARY/g, $interpolate('{{ \'months.JANUARY\' | translate}}'))
      .replace(/FEBRUARY/g, $interpolate('{{ \'months.FEBRUARY\' | translate}}'))
      .replace(/MARCH/g, $interpolate('{{ \'months.MARCH\' | translate}}'))
      .replace(/APRIL/g, $interpolate('{{ \'months.APRIL\' | translate}}'))
      .replace(/MAY/g, $interpolate('{{ \'months.MAY\' | translate}}'))
      .replace(/JUNE/g, $interpolate('{{ \'months.JUNE\' | translate}}'))
      .replace(/JULY/g, $interpolate('{{ \'months.JULY\' | translate}}'))
      .replace(/AUGUST/g, $interpolate('{{ \'months.AUGUST\' | translate}}'))
      .replace(/SEPTEMBER/g, $interpolate('{{ \'months.SEPTEMBER\' | translate}}'))
      .replace(/OCTOBER/g, $interpolate('{{ \'months.OCTOBER\' | translate}}'))
      .replace(/NOVEMBER/g, $interpolate('{{ \'months.NOVEMBER\' | translate}}'))
      .replace(/DECEMBER/g, $interpolate('{{ \'months.DECEMBER\' | translate}}'))
      ;
  };
}
